/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {BenjiKIV} from "../BenjiKIV";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class BenjiKIVIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xWays : false,
        xSplit: true,
        xNudge : true,
        xBet : false,
        volatility : Volatility.HIGH
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    // #278
    private _xBetRedDecided: boolean;
    private _gccApplied: boolean;
    private _resolve: (val: unknown) => void;

    constructor() {
        BenjiKIV.introConfigInstance = this;
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        return new Promise((resolve, reject) => {

            this.background = new PIXI.Container();
            const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
            bgSprite.anchor.set(0.5, 0.5);
            this.background.addChild(bgSprite);

            this.borderTop = new PIXI.Container();
            const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
            topSprite.anchor.set(0.5, 0.5);
            this.borderTop.addChild(topSprite);

            this.borderBottom = new PIXI.Container();
            const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
            bottomSprite.rotation = Math.PI;
            bottomSprite.anchor.set(0.5, 0.5);
            this.borderBottom.addChild(bottomSprite);

            this.logo = new PIXI.Container();

            const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
            featureSprite2.anchor.set(0.5, 0.5);

            const featureSprite3 = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
            featureSprite3.anchor.set(0.5, 0.5);

            this.pages = [
                new SlideShowPage(),
                new SlideShowPage()
            ];

            this.pages[0].addChild(featureSprite2);
            this.pages[1].addChild(featureSprite3);

            this._xBetRedDecided = false;
            this._gccApplied = false;
            this._resolve = resolve;
            if(BenjiKIV.apiPlugin.gameClientConfiguration.isSet) {
                this._gccApplied = true;
                this.addBoostPage();
                if(BenjiKIV.apiPlugin.gameClientConfiguration.boostedBetAllowed){
                    this.stampConfig.xBet = true;
                }
            } else {
                BenjiKIV.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    this._gccApplied = true;
                    this.addBoostPage();
                    if(BenjiKIV.apiPlugin.gameClientConfiguration.boostedBetAllowed){
                        this.stampConfig.xBet = true;
                    }
                });
            }
        });
    }

    public onClose():void {
        this.logo.destroy({children : true, texture : true, baseTexture : true});
        this.background.destroy({children : true, texture : true, baseTexture : true});
        this.borderTop.destroy({children : true, texture : true, baseTexture : true});
        this.borderBottom.destroy({children : true, texture : true, baseTexture : true});
    }

    // #278
    public onXBetRedDecided(): void {
        this._xBetRedDecided = true;
        this.addBoostPage();
    }

    private addBoostPage(): void {
        // #278
        if (this._xBetRedDecided && this._gccApplied) {
            // condition changed as per https://github.com/nolimitcity/QA/issues/587
            if (BenjiKIV.apiPlugin.gameClientConfiguration.boostedBetAllowed && BenjiKIV.xBetRedAllowed) {
                const betBoostImage = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
                betBoostImage.anchor.set(0.5, 0.5);
                const page = new SlideShowPage();
                page.addChild(betBoostImage);
                // page.name = "boostedPage";
                this.pages.splice(0, 0, page);
            }

            this._xBetRedDecided = false;
            this._gccApplied = false;

            this._resolve(this);
        }
    }
}
